/* file description */

import { Button, message } from 'antd';
import React from 'react';
import RuleController from '@/components/RuleController';
import _ from 'lodash';
import { AbilityPoint } from '@/const';

import type { UseToolBarRenderProp } from './type';

export const useToolBarRender: UseToolBarRenderProp = ({
  toolBarRender = [],
  fileModule,
  setUploadWrap,
  canImport,
  setImportVisible,
  moduleID,
  headerBtns,
  rowSelection,
  setExportVisible,
}) => {
  const loadScript = (url: string, callback: any) => {
    if (window.XLSX) {
      callback();
      return;
    }
    const script = document.createElement('script');
    script.src = url;
    script.onload = callback;
    document.body.appendChild(script);
  };

  let result: any[] = [];
  if (headerBtns?.includes('export-btns')) {
    result.push((
      <RuleController id="export-btns" ability={AbilityPoint.canExport} moduleCode={moduleID}>
        <Button
          key="export"
          onClick={() => {
            setExportVisible(true);
          }}
          type="primary"
          ghost
        >
          {rowSelection ? '批量导出' : '导出'}
        </Button>
      </RuleController>
    ));
  }

  if (fileModule) {
    result.push(
      <RuleController id={`${moduleID}.upload-btns`}>
        <Button
          key="button"
          onClick={() => {
            setUploadWrap(true);
          }}
          type="primary"
          ghost
        >
          上传附件
        </Button>
      </RuleController>,
    );
  }

  if (canImport) {
    result.push(
      <RuleController id={`${moduleID}.import-btns`} ability={AbilityPoint.canImport} moduleCode={moduleID}>
        <Button
          key="import"
          onClick={() => {
            loadScript('/static/js/xlsx/0.17.5/xlsx.full.min.js', () => {
              setImportVisible(true);
            });
          }}
          type="primary"
          ghost
        >
          导入
        </Button>
      </RuleController>,
    );
  }
  if (_.isArray(toolBarRender)) {
    result = [...toolBarRender, ...result];
  } else if (_.isObject(toolBarRender)) {
    result.push(toolBarRender);
  }
  return () => {
    return result;
  };
};
